// Phase 9B — TrustPage.
//
// Route-level wrapper for Trust Center / Knowledge Base.

import { TrustCenterPage } from "../../modes/trust/TrustCenterPage.tsx";

export function TrustPage(): JSX.Element {
  return <TrustCenterPage />;
}
